<nz-upload 
  nzType="drag" 
  [nzMultiple]="documentClassification === 1" 
  [nzShowUploadList]="false"
  [nzCustomRequest]="customRequest"
  style="height: 20px !important;"
  >
      <p class="ant-upload-drag-icon">
        <nz-icon nzType="inbox" />
      </p>
      <p class="ant-upload-text">Click or drag files to this area to upload</p>
      <p class="ant-upload-hint">
        Once files are uploaded, they will be processed automatically.
      </p>
</nz-upload>

@if (uploadFiles.length > 0) {
  <nz-list nzBordered [nzDataSource]="uploadFiles" nzSize="small" style="margin-top: 16px;">
    <nz-list-item *ngFor="let file of uploadFiles">
      <div style="display: flex; align-items: center; width: 100%;">
        <span style="flex: 1;">{{ file.name }}</span>
        @if (file.status === 'pending') {
          <nz-spin nzSimple [nzSize]="'small'" style="margin-right: 8px;"></nz-spin>
          <nz-tag nzColor="blue">Uploading...</nz-tag>
        }
        @if (file.status === 'success') {
          <nz-icon nzType="check-circle" nzTheme="fill" style="color: #52c41a; font-size: 16px; margin-right: 8px;"></nz-icon>
          <nz-tag nzColor="success">Uploaded</nz-tag>
        }
        @if (file.status === 'error') {
          <nz-icon nzType="close-circle" nzTheme="fill" style="color: #ff4d4f; font-size: 16px; margin-right: 8px;"></nz-icon>
          <nz-tag nzColor="error">Failed</nz-tag>
        }
      </div>
    </nz-list-item>
  </nz-list>
}